const config = {
    websiteName: process.env.REACT_APP_WEBSITE_NAME,
    baseUrl: process.env.REACT_APP_BASE_URL,
    supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
    appVersion: process.env.REACT_APP_APP_VERSION,
    showFreeMonth: process.env.REACT_APP_SHOW_FREE_MONTH === 'true',
     // ✅ add these
  showFreeCredit: process.env.REACT_APP_SHOW_FREE_CREDIT === 'true',
  freeCreditCount: Number(process.env.REACT_APP_FREE_CREDIT_COUNT || 1),

    signInUrl: process.env.REACT_APP_SIGNIN_URL,
    signUpUrl: process.env.REACT_APP_SIGNUP_URL,
  };
  
  export default config;